import React from 'react';
import { useIntl } from 'react-intl';
import application from 'services/application';
import navigation from 'services/navigation';
import Button from 'components/button';

import loginMessages from '../login/login.i18n';
import signupMessages from '../signup/registration/registration.i18n';

interface AppHeaderControlsProps {
  login?: boolean;
  signup?: boolean;
  languageSelector?: () => React.ReactNode;
}

const AppHeaderControls: React.FunctionComponent<AppHeaderControlsProps> = (props) => {
  const { login, signup, languageSelector } = props;
  const { formatMessage } = useIntl();

  React.useEffect(() => {
    application.header.setContent(
      <div className="d-inline-flex align-items-center gap-1">
        {languageSelector?.()}
        <div className="ms-2 text-nowrap">
          {signup && (
            <Button onClick={() => navigation.signup({})} size="xs" className={login && 'me-2'}>
              {formatMessage(loginMessages.pages.login.signup[application.current].cta)}
            </Button>
          )}
          {login && (
            <Button onClick={() => navigation.login()} variant="secondary1" size="xs">
              {formatMessage(signupMessages.pages.signup.registration.login[application.current].cta)}
            </Button>
          )}
        </div>
      </div>
    );

    return () => {
      application.header.clearContent();
    };
  }, [formatMessage, login, signup, languageSelector]);

  return null;
};

export type { AppHeaderControlsProps };
export default AppHeaderControls;
